import { Language } from "../../Types/types";

export const languages: { code: Language; name: string; flag: string }[] = [
  { code: "en", name: "EN", flag: "/flags/en.png" },
  { code: "cz", name: "CZ", flag: "/flags/cz.png" },
  { code: "sk", name: "SK", flag: "/flags/sk.png" },
  { code: "de", name: "DE", flag: "/flags/de.png" },
  { code: "hu", name: "HU", flag: "/flags/hu.png" },
  { code: "pl", name: "PL", flag: "/flags/pl.png" },
  { code: "fr", name: "FR", flag: "/flags/fr.png" },
  { code: "es", name: "ES", flag: "/flags/es.png" },
  { code: "nl", name: "NL", flag: "/flags/nl.png" },
  { code: "sv", name: "SV", flag: "/flags/sv.png" },
  { code: "fi", name: "FI", flag: "/flags/fi.png" },
  { code: "da", name: "DA", flag: "/flags/da.png" },
  { code: "no", name: "NO", flag: "/flags/no.png" },
  { code: "ru", name: "RU", flag: "/flags/ru.png" },
  { code: "ar", name: "AR", flag: "/flags/ar.png" },
];
